import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16 28C16.7956 28 17.5587 27.6839 18.1213 27.1213C18.6839 26.5587 19 25.7956 19 25H13C13 25.7956 13.3161 26.5587 13.8787 27.1213C14.4413 27.6839 15.2044 28 16 28Z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M24 18V14C24.0013 12.1586 23.3673 10.373 22.205 8.94475C21.0427 7.51647 19.4233 6.53289 17.62 6.16C17.8695 5.82496 18.0029 5.41771 18 5C18 4.46957 17.7893 3.96086 17.4142 3.58579C17.0391 3.21071 16.5304 3 16 3C15.4696 3 14.9609 3.21071 14.5858 3.58579C14.2107 3.96086 14 4.46957 14 5C13.9971 5.41771 14.1305 5.82496 14.38 6.16C12.5767 6.53289 10.9573 7.51647 9.79496 8.94475C8.63266 10.373 7.99868 12.1586 8 14V18L5 21V23H27V21L24 18Z","fill":"currentColor"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
